export default __webpack_public_path__ + "static/media/bg14.ba77ded9.svg";